var map = {
	"./data-search.de-CH.json": 971,
	"./data-search.de-DE.json": 972,
	"./data-search.en-CA.json": 973,
	"./data-search.en-GB.json": 974,
	"./data-search.en-IN.json": 975,
	"./data-search.en-ME.json": 976,
	"./data-search.en-US.json": 977,
	"./data-search.es-EM.json": 978,
	"./data-search.es-ES.json": 979,
	"./data-search.fr-BE.json": 980,
	"./data-search.fr-CA.json": 981,
	"./data-search.fr-CH.json": 982,
	"./data-search.nl-BE.json": 983,
	"./data-search.nl-NL.json": 984,
	"./data-search.pl-PL.json": 985,
	"./data-search.pt-BR.json": 986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;